/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-19 13:24:41
 * @LastEditTime: 2019-08-23 13:18:53
 * @LastEditors: Please set LastEditors
 */
'use strict'
import device from './device'

var JsBridgePlugin = {};

JsBridgePlugin.install = function (Vue, option) {

  //初始化jsBridge
  Vue.prototype.$jsBridge = {
    registerHandler: function (name, callback) {
      console.error('没有注册成功')
    },
    callHandler: function (name, params, callback) {
      console.error('没有调用成功')
      // callback('error')
    }
  }
  //所有原生和js通信的命令
  Vue.prototype.$jsBridgeCmd = {
    getBackgroundColor: 'getBackgroundColor',
    getAppToken: 'getAppToken',//app登录获取token
    appLogin: 'appLogin',//去登录
    appLogout: 'appLogout',//token过期退出登录
    appSharing: 'appSharing',  //分享 参数{img:'' ,text:'', url:'', title:''}
    goBack: 'goBack', //返回上一页
    goAuthentication: 'goAuthentication',   //实名认证
    appDownImg: 'appDownImg',
    goInvite: 'goInvite',    // 去邀请好友
    appRecharge: 'appRecharge', // 去充值
    appSpot: 'appSpot', // 去现货交易
    appContract: 'appContract', // 去合约交易
    goBrowser: 'goBrowser',  // 跳转到浏览器
    openModel: 'openModel',   // 打开弹框
    submitApp: 'submitApp',
    appRegister: 'appRegister',  // app注册
    appCustomerService: 'appCustomerService',//联系客服
    appP2P:'appP2P',//app中的p2p
    appShowOff:'appShowOff',//炫耀一下
    appVerification:'appVerification',//去认证
  }

  //先注释掉 初始化jsBridge 需要用到时再初始化
  // if(device.webView){
  if (device.android) {
    androidSetWebViewJavascriptBridge(function (bridge) {
      Vue.prototype.$jsBridge = bridge;
      console.log('初始化$jsBridge' + (typeof bridge.registerHandler == 'function'))

    })
  } else if (device.ios) {
    iosSetupWebViewJavascriptBridge(function (bridge) {
      Vue.prototype.$jsBridge = bridge

      // console.log('初始化$jsBridge',Vue.prototype.$jsBridge)
    })
  }
  // }

};
export default JsBridgePlugin;

//安卓
export function androidSetWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    console.log('有WebViewJavascriptBridge对象')
    return callback(WebViewJavascriptBridge)
  } else {

    console.log('没有WebViewJavascriptBridge对象,等待WebViewJavascriptBridgeReady事件回调')
    // setTimeout(()=>{
    //     console.log('WebViewJavascriptBridgeReady事件回调了')
    //         callback(WebViewJavascriptBridge)
    // },10000)
    document.addEventListener('WebViewJavascriptBridgeReady', function () {
      console.log('WebViewJavascriptBridgeReady事件回调了')
      callback(WebViewJavascriptBridge)
    },
      false
    );
    // document.addEventListener('WebViewJavascriptBridgeReady', function (event) {
    //     console.log('WebViewJavascriptBridgeReady事件回调了')
    //     if(window.onWebViewJavascriptBridgeReady) window.onWebViewJavascriptBridgeReady(window.__bridge = WebViewJavascriptBridge);
    //     callback(WebViewJavascriptBridge)
    // }, false)
  }
}

//ios
export function iosSetupWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(WebViewJavascriptBridge);
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  window.WVJBCallbacks = [callback];
  var WVJBIframe = document.createElement('iframe');
  WVJBIframe.style.display = 'none';
  WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function () {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)
}

let func = function () {

};
if (device.webView) {
  if (device.android) {
    func = androidSetWebViewJavascriptBridge
  } else if (device.ios) {
    func = iosSetupWebViewJavascriptBridge
  }
}

//在路由中使用这个方法 注册web方法让原生调用
export let setJsBridge = func;



// WEBPACK FOOTER //
// ./src/utils/jsBridge-plugin.js